// src/hooks/useAppConfig.js
import { computed,ref } from 'vue';

export default function useAppConfig() {
  const config = computed(() => window.__APP_CONFIG__ || {});

  const isJJW = computed(() => {
    const apiBaseUrl = config.value.apiBaseUrl || '';
    return apiBaseUrl.includes('www.jijianwang.cn') || apiBaseUrl.includes('local-dev.58mhg.com');
  });
  const isBFZS = computed(() => {
    const apiBaseUrl = config.value.apiBaseUrl || '';
    return apiBaseUrl.includes('www.caipianos.com') || apiBaseUrl.includes('dev.jijianwang.cn');
  });
  return {
    config,
    isJJW,
    isBFZS,
  };
}